<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <v-container
    id="data-tables"
    class="fill-height align-start"
    fluid
    tag="section"
  >
    <v-container
      fluid
    >
      <ik-data-table
        :model="model"
        entity-name="orderDishesGroupConfig"
        icon="mdi-cash-usd"
      />
    </v-container>
  </v-container>
</template>

<script>

import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import OrderDishesGroup from '@/model/dataLayer/api/restaurant/OrderDishesGroup'

export default {
  components: {
    IkDataTable
  },
  data: function () {
    return ({
      model: OrderDishesGroup
    })
  }
}
</script>
